import type { LanguageCode } from "../languages";
import type { Translations } from "../types";

import en from "./en";
import es from "./es";
import pt from "./pt";
import fr from "./fr";
import de from "./de";
import it from "./it";
import ru from "./ru";
import zh from "./zh";
import ja from "./ja";
import ko from "./ko";
import hi from "./hi";
import ar from "./ar";
import bn from "./bn";
import ur from "./ur";
import id from "./id";
import ms from "./ms";
import vi from "./vi";
import th from "./th";
import tr from "./tr";
import fa from "./fa";
import pl from "./pl";
import uk from "./uk";
import nl from "./nl";
import sv from "./sv";
import no from "./no";
import da from "./da";
import fi from "./fi";
import el from "./el";
import cs from "./cs";
import sk from "./sk";
import hu from "./hu";
import ro from "./ro";
import bg from "./bg";
import hr from "./hr";
import sr from "./sr";
import sl from "./sl";
import he from "./he";
import sw from "./sw";
import tl from "./tl";
import ta from "./ta";

// One entry per code in SUPPORTED_LANGUAGES (src/i18n/languages.ts) - kept
// as a `Record<LanguageCode, Translations>` (rather than e.g. a dynamic
// import() per language) so that a language missing its file is a compile
// error here, not a runtime surprise the first time a visitor picks it.
export const translations: Record<LanguageCode, Translations> = {
  en,
  es,
  pt,
  fr,
  de,
  it,
  ru,
  zh,
  ja,
  ko,
  hi,
  ar,
  bn,
  ur,
  id,
  ms,
  vi,
  th,
  tr,
  fa,
  pl,
  uk,
  nl,
  sv,
  no,
  da,
  fi,
  el,
  cs,
  sk,
  hu,
  ro,
  bg,
  hr,
  sr,
  sl,
  he,
  sw,
  tl,
  ta,
};
